import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "About the Name Freon",
description: "Explains the origin of the name Freon — from its early days as ProjectIt to its meaning as ‘friend’ in Frisian — and includes the myth of Freon, the God of languages.",
tags: [ "Freon", "name", "origin", "ProjectIt", "mythology", "linguistics", "Frisian", "god of languages", "story", "background", "documentation"] ,
modifiedTime: "2025-11-07T17:20:18.649Z",
publishedTime: "2025-11-07T17:20:18.649Z"
    }
  };
};